<template>

    <div class="mx-sm-1 mt-9">
        <div class="page-header">
            <h1 class="page-title fw-bold">OJECTIFS ET INDICATEURS DE PERFORMANCE</h1>
            <div>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><router-link :to="{ name: 'dashboard' }"><a>Tableau de
                                bord</a></router-link></li>
                    <li class="breadcrumb-item active" aria-current="page"><router-link
                            :to="{ name: 'verificationCadrage' }"><a>Objectifs et indicateurs de
                                performance</a></router-link></li>
                </ol>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label class="form-label">Année <span class="text-danger">*</span></label>
                                    <multi-select deselect-label="Sélectionné" select-label="" :options="exercices"
                                        @select="selectAnnee" placeholder="Sélectionné " label="annee" track-by="annee"
                                        :searchable="true" :custom-label="o => o.annee" v-model="payload.exercice">
                                        <template slot="singleLabel" slot-scope="{ option }">
                                            <strong> {{ option.annee }}</strong>
                                        </template>
                                        <span slot="noOptions">
                                            <strong>Liste Vide</strong>
                                        </span>
                                        <span slot="noResult">
                                            <strong>Aucun Résultat</strong>
                                        </span>
                                    </multi-select>
                                </div>
                            </div>

                        </div>

                        <hr>

                        <div class="modal fade" id="detail-objectif" tabindex="-1" role="dialog">
                            <div class="modal-dialog modal-fullscreen modal-dialog-scrollable" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-primary text-white">
                                        <h6 class="modal-title fw-bold" style="font-size: 16px;">Détail
                                            objectif/Indicateur
                                            séléctionnée
                                        </h6>
                                        <button aria-label="Close" class="btn-close text-white" data-bs-dismiss="modal"
                                            type="button"><span aria-hidden="true">×</span></button>
                                    </div>
                                    <div class="modal-body">
                                        <div class="row">
                                            <div class="col-md-2">
                                                <div class="card h-100">
                                                    <div class="card-body alert alert-secondary shadow shadow">

                                                        <p class="card-text fw-bold">
                                                            <i class="fe fe-tag fs-18"></i>{{
                                                                objectif.annee?.annee ?
                                                                    objectif.annee?.annee : '---' }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-2 ">
                                                <div class="card h-100">
                                                    <div class="card-body alert alert-secondary shadow shadow">

                                                        <p class="card-text fw-bold">
                                                            <i class="fe fe-tag fs-18"></i>{{
                                                                objectif.idPta?.idPtaAsin ?
                                                                    objectif.idPta?.idPtaAsin : '---' }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-2 ">
                                                <div class="card h-100">
                                                    <div class="card-body alert alert-secondary shadow shadow">

                                                        <p class="card-text fw-bold">
                                                            <i class="fe fe-tag fs-18"></i>{{
                                                                objectif.idDetails?.nomDetail ?
                                                                    objectif.idDetails?.nomDetail : '---' }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-2">
                                                <div class="card h-100">
                                                    <div class="card-body alert alert-secondary shadow shadow">

                                                        <p class="card-text fw-bold">
                                                            <i class="fe fe-tag fs-18"></i>{{
                                                                objectif?.pole ?
                                                                    objectif?.pole : '---' }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-2">
                                                <div class="card h-100">
                                                    <div class="card-body alert alert-secondary shadow shadow">

                                                        <p class="card-text fw-bold">
                                                            <i class="fe fe-tag fs-18"></i>{{
                                                                objectif?.responsable ?
                                                                    objectif?.responsable : '---' }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-2">
                                                <div class="card h-100">
                                                    <div class="card-body alert alert-secondary shadow shadow">

                                                        <p class="card-text fw-bold">
                                                            <i class="fe fe-tag fs-18"></i>{{
                                                                objectif?.pmo ?
                                                                    objectif?.pmo : '---' }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-2">


                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <label class="form-label">Echéance prévue <span
                                                            class="text-danger">*</span></label>
                                                    <multi-select :disabled="prevu==false" deselect-label="Sélectionné" select-label=""
                                                        :options="echeances" placeholder="Sélectionné " label="echeance"
                                                        track-by="idEcheance" :searchable="true"
                                                        :custom-label="o => o.libelleEcheance"
                                                        v-model="objectif.idEcheancePrevue">
                                                        <template slot="singleLabel" slot-scope="{ option }">
                                                            <strong> {{ option.libelleEcheance }}</strong>
                                                        </template>
                                                        <span slot="noOptions">
                                                            <strong>Liste Vide</strong>
                                                        </span>
                                                        <span slot="noResult">
                                                            <strong>Aucun Résultat</strong>
                                                        </span>
                                                    </multi-select>
                                                </div>
                                            </div>

                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <label class="form-label">Echéance réalisée <span
                                                            class="text-danger">*</span></label>
                                                    <multi-select :disabled="prevu==false" deselect-label="Sélectionné" select-label=""
                                                        :options="echeances" placeholder="Sélectionné " label="echeance"
                                                        track-by="idEcheance" :searchable="true"
                                                        :custom-label="o => o.libelleEcheance"
                                                        v-model="objectif.idEcheanceAtteinte">
                                                        <template slot="singleLabel" slot-scope="{ option }">
                                                            <strong> {{ option.libelleEcheance }}</strong>
                                                        </template>
                                                        <span slot="noOptions">
                                                            <strong>Liste Vide</strong>
                                                        </span>
                                                        <span slot="noResult">
                                                            <strong>Aucun Résultat</strong>
                                                        </span>
                                                    </multi-select>
                                                </div>
                                            </div>

                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <label class="form-label">Type de mesure <span
                                                            class="text-danger">*</span></label>
                                                    <multi-select :disabled="prevu==false" deselect-label="Sélectionné" select-label=""
                                                        :options="typeMesures" placeholder="Sélectionné "
                                                        label="typeMesure" track-by="typeMesure" :searchable="true"
                                                        :custom-label="o => o.typeMesure" v-model="objectif.typeMesure">
                                                        <template slot="singleLabel" slot-scope="{ option }">
                                                            <strong> {{ option.typeMesure }}</strong>
                                                        </template>
                                                        <span slot="noOptions">
                                                            <strong>Liste Vide</strong>
                                                        </span>
                                                        <span slot="noResult">
                                                            <strong>Aucun Résultat</strong>
                                                        </span>
                                                    </multi-select>
                                                </div>
                                            </div>

                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <label class="form-label">Source indicateur <span
                                                            class="text-danger">*</span></label>
                                                    <multi-select :disabled="prevu==false" deselect-label="Sélectionné" select-label=""
                                                        :options="sourceIndicateurs" @select="selectAnnee"
                                                        placeholder="Sélectionné " label="source"
                                                        track-by="idSourceIndicateur" :searchable="true"
                                                        :custom-label="o => o.libelleSourceIndicateur"
                                                        v-model="objectif.idSourceIndicateur">
                                                        <template slot="singleLabel" slot-scope="{ option }">
                                                            <strong> {{ option.libelleSourceIndicateur }}</strong>
                                                        </template>
                                                        <span slot="noOptions">
                                                            <strong>Liste Vide</strong>
                                                        </span>
                                                        <span slot="noResult">
                                                            <strong>Aucun Résultat</strong>
                                                        </span>
                                                    </multi-select>
                                                </div>
                                            </div>



                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <label class="form-label">Producteur <span
                                                            class="text-danger">*</span></label>
                                                    <multi-select :disabled="prevu==false" deselect-label="Sélectionné" select-label=""
                                                        :options="producteurs" placeholder="Sélectionné "
                                                        label="producteur" track-by="idProducteur" :searchable="true"
                                                        :custom-label="o => o.nomProducteur"
                                                        v-model="objectif.idProducteur">
                                                        <template slot="singleLabel" slot-scope="{ option }">
                                                            <strong> {{ option.nomProducteur }}</strong>
                                                        </template>
                                                        <span slot="noOptions">
                                                            <strong>Liste Vide</strong>
                                                        </span>
                                                        <span slot="noResult">
                                                            <strong>Aucun Résultat</strong>
                                                        </span>
                                                    </multi-select>
                                                </div>
                                            </div>

                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <label class="form-label">Type Indicateur <span
                                                            class="text-danger">*</span></label>
                                                    <multi-select :disabled="prevu==false" deselect-label="Sélectionné" select-label=""
                                                        :options="typeIndicateurs" placeholder="Sélectionné "
                                                        label="INDICATEUR" track-by="idTypeIndicateur"
                                                        :searchable="true" :custom-label="o => o.libelleTypeIndicateur"
                                                        v-model="objectif.idTypeIndicateur">
                                                        <template slot="singleLabel" slot-scope="{ option }">
                                                            <strong> {{ option.libelleTypeIndicateur }}</strong>
                                                        </template>
                                                        <span slot="noOptions">
                                                            <strong>Liste Vide</strong>
                                                        </span>
                                                        <span slot="noResult">
                                                            <strong>Aucun Résultat</strong>
                                                        </span>
                                                    </multi-select>
                                                </div>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="row mt-3">
                                            <div class="form-group d-flex">
                                                <div class="col-sm-6">
                                                    <label for="">Résultats attendus</label>
                                                    <input :disabled="prevu==false" class="form-control" v-model="objectif.resultatsAtt"
                                                        placeholder="Résultats attendus" type="text">
                                                </div>
                                                <div class="col-sm-6">
                                                    <label for="">Indicateurs de mesure du résultat</label>
                                                    <input :disabled="prevu==false" class="form-control" v-model="objectif.indicateur"
                                                        placeholder="Indicateurs de mesure du résultat" type="text">
                                                </div>
                                            </div>
                                        </div>

                                        <hr>
                                        <div class="container-fluid">
                                            <div class="row">
                                                <div class="d-flex flex-wrap w-100 justify-content-between gap-4">

                                                    <!-- Bloc Prévisions et Réalisations -->
                                                    <div class="flex-grow-1"
                                                        style="min-width: 300px; max-width: 1000px;">
                                                        <h5 class="fw-bold">Prévisions et réalisations</h5>
                                                        <hr>
                                                        <div class="row mb-2 fw-bold">
                                                            <div class="col-6">Prévu</div>
                                                            <div class="col-6">Réalisé</div>
                                                        </div>

                                                        <!-- Trimestres -->
                                                        <div class="row mb-2">
                                                            <div class="col-6">
                                                                <input :disabled="prevu==false" type="text" v-model="objectif.t1Prevu"
                                                                    placeholder="Trimestre 1" class="form-control">
                                                            </div>
                                                            <div class="col-6">
                                                                <input type="text" v-model="objectif.t1Realise"
                                                                    placeholder="Trimestre 1" class="form-control">
                                                            </div>
                                                        </div>
                                                        <div class="row mb-2">
                                                            <div class="col-6">
                                                                <input :disabled="prevu==false" type="text" v-model="objectif.t2Prevu"
                                                                    placeholder="Trimestre 2" class="form-control">
                                                            </div>
                                                            <div class="col-6">
                                                                <input type="text" v-model="objectif.t2Realise"
                                                                    placeholder="Trimestre 2" class="form-control">
                                                            </div>
                                                        </div>
                                                        <div class="row mb-2">
                                                            <div class="col-6">
                                                                <input :disabled="prevu==false" type="text" v-model="objectif.t3Prevu"
                                                                    placeholder="Trimestre 3" class="form-control">
                                                            </div>
                                                            <div class="col-6">
                                                                <input type="text" v-model="objectif.t3Realise"
                                                                    placeholder="Trimestre 3" class="form-control">
                                                            </div>
                                                        </div>
                                                        <div class="row mb-2">
                                                            <div class="col-6">
                                                                <input :disabled="prevu==false" type="text" v-model="objectif.t4Prevu"
                                                                    placeholder="Trimestre 4" class="form-control">
                                                            </div>
                                                            <div class="col-6">
                                                                <input type="text" v-model="objectif.t4Realise"
                                                                    placeholder="Trimestre 4" class="form-control">
                                                            </div>
                                                        </div>
                                                        <hr>
                                                        <div class="row mb-2 fw-bold">
                                                            <div class="col-6">Cible :
                                                                {{ sommePrevu.toLocaleString('fr-FR') }}</div>
                                                            <div class="col-6">Réalisé : {{
                                                                sommeRealise.toLocaleString('fr-FR') }}</div>
                                                        </div>
                                                    </div>

                                                    <!-- Divider -->
                                                    <div class="vr d-none d-md-block"></div>

                                                    <!-- Bloc Récapitulatif -->
                                                    <div class="flex-grow-1"
                                                        style="min-width: 300px; max-width: 500px;">
                                                        <h5 class="fw-bold">Récapitulatif</h5>
                                                        <hr>
                                                        <div class="row mb-2">
                                                            <div class="col-12 col-md-6 mb-2">
                                                                <p class="fw-bold btn btn-outline-primary w-100">
                                                                    Taux de réalisation (
                                                                    {{ sommePrevu && sommePrevu != 0 ? ((sommeRealise /
                                                                        sommePrevu) *
                                                                        100).toFixed(2) : '0.00' }} %
                                                                    )
                                                                </p>
                                                            </div>

                                                            <div class="col-12 col-md-6 mb-2">
                                                                <p class="fw-bold btn btn-outline-primary w-100">
                                                                    Objectif atteint ? (
                                                                    {{ sommePrevu && sommePrevu != 0 && ((sommeRealise /
                                                                        sommePrevu) *
                                                                        100).toFixed(2) == 100.00 ? 'Oui' : 'Non' }}
                                                                    )
                                                                </p>
                                                            </div>



                                                            <div class="flex-grow-1"
                                                                style="min-width: 300px; max-width: 500px;">
                                                                <label class="form-label fw-bold">Commentaire</label>
                                                                <textarea name="commentaire"
                                                                    v-model="objectif.commentaire" class="form-control"
                                                                    rows="5"></textarea>
                                                            </div>

                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="modal-footer">
                                        <button class="btn btn-primary" @click="saver(objectif)">Enregistrer</button>
                                        <button class="btn btn-gray" data-bs-dismiss="modal">Fermer</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <p class="fw-bold underline">Liste des objectifs et indicateurs de performance</p>
                            <table class="table table-hover table-bordered text-wrap border-bottom mb-0" id="my">
                                <thead class="border-top text-white" style="background-color: #457e9e!important;">
                                    <tr class="fw-bold">
                                        <th class="bg-transparent border-bottom-0 fw-bold" style=""
                                            @click="sortBy('action')">Composante</th>
                                        <th class="bg-transparent border-bottom-0 fw-bold"
                                            @click="sortBy('montantCpBn')">Id PTA Interne
                                        </th>
                                        <th class="bg-transparent border-bottom-0 fw-bold"
                                            @click="sortBy('montantCpBn')">Description
                                        </th>
                                        <th class="bg-transparent border-bottom-0 fw-bold"
                                            @click="sortBy('montantCpBn')">Résultats attendus
                                        </th>
                                        <th class="bg-transparent border-bottom-0 fw-bold"
                                            @click="sortBy('montantCpBn')">Indicateur de mesure
                                            du resultat
                                        </th>
                                        <th class="bg-transparent border-bottom-0 fw-bold"
                                            @click="sortBy('montantCpBn')">Echéance prévue
                                        </th>
                                        <th class="bg-transparent border-bottom-0 fw-bold"
                                            @click="sortBy('montantCpBn')">Pole
                                        </th>
                                        <th class="bg-transparent border-bottom-0 fw-bold"
                                            @click="sortBy('montantCpBn')">Responsable
                                        </th>
                                        <th class="bg-transparent border-bottom-0 fw-bold"
                                            @click="sortBy('montantCpBn')">PMO
                                        </th>
                                        <th class="bg-transparent border-bottom-0 fw-bold" style="width: 5%;">Actions
                                        </th>
                                    </tr>
                                </thead>

                                <tfoot>
                                    <tr class="fw-bold bg-light">
                                        <td colspan="10"></td>
                                    </tr>

                                </tfoot>

                                <tbody v-if="sortedItems.length > 0" id="myTable1">
                                    <template v-for="(item, index) in sortedItems">
                                        <!-- Ligne principale -->
                                        <tr class="border-bottom" style="background-color: #d0e6e9;">
                                            <td colspan="9">
                                                <p class="fw-bold mb-0 text-break"
                                                    style="white-space: normal; word-break: break-word;">
                                                    {{ item?.projet }}
                                                </p>
                                            </td>
                                            <td class="text-end">
                                                <button class="btn btn-warning btn-sm text-white "
                                                    @click.prevent="toggleDetail(item)">
                                                    <span class="fe fe-eye fs-18"></span>
                                                </button>
                                            </td>
                                        </tr>

                                        <!-- Composantes, affichées uniquement si item sélectionné -->
                                        <tr v-for="(projet, idx) in item.items" :key="`compo-${index}-${idx}`"
                                            v-if="selectedItem === item || selectedItem === 'ALL'">
                                            <td colspan="1">{{ projet?.idDetails?.idComposante.nomComposante }}</td>

                                            <td class="text-end">
                                                {{ projet?.idPta?.idPtaAsin }}
                                            </td>
                                            <td class="text-end">
                                                {{ projet?.idDetails?.nomDetail }}
                                            </td>
                                            <td class="text-end">
                                                {{ projet?.resultatsAtt }}
                                            </td>
                                            <td class="text-end">
                                                {{ projet?.indicateur }}
                                            </td>

                                            <td class="text-end">
                                                {{ projet?.idEcheancePrevue?.libelleEcheance }}
                                            </td>
                                            <td class="text-end">
                                                {{ projet?.pole }}
                                            </td>
                                            <td class="text-end">
                                                {{ projet?.responsable }}
                                            </td>
                                            <td class="text-end">
                                                {{ projet?.pmo }}
                                            </td>
                                            <td class="text-center d-flex">

                                                <button class="btn btn-primary btn-sm text-white me-1"
                                                    @click="showPrevention(projet,true)" >
                                                    Prévision

                                                </button>

                                                <button class="btn btn-success btn-sm text-white"  @click="showPrevention(projet,false)" :disabled="!projet.t1Prevu || !projet.t2Prevu || !projet.t3Prevu || !projet.t4Prevu">
                                                    Réalisation
                                                    <span class="fe fe-check fs-18"></span>
                                                </button>
                                            </td>

                                        </tr>
                                    </template>
                                </tbody>

                                <tbody v-else>
                                    <tr class="primary02">
                                        <td colspan="10" class="text-center">Aucun Cadrages trouvé</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <nav v-if="pageCount > 1" class="mt-2">
                            <ul class="pagination justify-content-end">
                                <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                    <a class="page-link" href="#"
                                        @click.prevent="changePage(currentPage - 1)">&laquo;</a>
                                </li>
                                <li v-for="page in pageCount" :key="page" class="page-item"
                                    :class="{ active: currentPage === page }">
                                    <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
                                </li>
                                <li class="page-item" :class="{ disabled: currentPage === pageCount }">
                                    <a class="page-link" href="#"
                                        @click.prevent="changePage(currentPage + 1)">&raquo;</a>
                                </li>
                            </ul>
                        </nav>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//import $ from 'jquery';
import { mapGetters, mapActions } from 'vuex';
import * as lang from "vuejs-datepicker/src/locale";
export default {
    name: "GenerationPta",
    data() {
        return {
            localItems: [], selectedItem: null, objectif: [],prevu:true,
            lang: lang, payload: { currentStep: 1, classeur: null, composante: "" }, pta: { idDetail: "", annee: "", dateDebut: "", dateFin: "", description: "", besoinAeBnTtc: 0, besoinAePretTtc: 0, besoinAeDonTtc: 0, besoinAeAntTtc: 0, besoinAeBaTtc: 0, besoinAeTotTtc: 0, besoin_cp_bn_ttc: 0, besoinCpPretTtc: 0, besoinCpDonTtc: 0, besoinCpAntTtc: 0, besoinCpBaTtc: 0, besoinCpTotTtc: 0 },
            save: true, showList: true, notModified: false, choixCompo: false, choixAnnee: false,
            producteurs: [], sourceIndicateurs: [], typeMesures: [], Echeances: [], typeIndicateurs: [],
            classeurs: [], composantes: [], exercices: [], typologies: [], lesactivites: [], lestaches: [], ptas: [], activite: null
        }
    },
    computed: {
        ...mapGetters({ items: 'projetPag/list' }),
        fr() {
            return this.lang.fr;
        },
        activeStep() {
            return this.steps[this.payload.currentStep - 1];
        },
        isLastStep() {
            return this.payload.currentStep === this.steps.length;
        },
        filtersItems() {
            const start = (this.currentPage - 1) * this.perPage;
            return this.sortedItems.slice(start, start + this.perPage);
        },
        groupedItems() {
            return this.localItems.reduce((groups, item) => {
                const projetKey = item?.idDetails?.idComposante?.idSsProjPag?.idProjetPag?.idProjetPag || 'Autre';
                if (!groups[projetKey]) {
                    groups[projetKey] = {
                        projet: item?.idDetails?.idComposante?.idSsProjPag?.idProjetPag?.nomProjetPag || 'Autre',
                        items: []
                    };
                }
                groups[projetKey].items.push(item);
                return groups;
            }, {});
        },
        sortedItems() {
            console.log(this.groupedItems);
            return Object.values(this.groupedItems).sort((a, b) => {
                const aVal = this.resolveSortValue(a);
                const bVal = this.resolveSortValue(b);
                return this.currentSortDir === 'asc'
                    ? (aVal > bVal ? 1 : -1)
                    : (aVal < bVal ? 1 : -1);
            });
        },

        pageCount() {

            return Math.ceil(this.sortedItems.length / this.perPage);
        },
        sommePrevu() {
            return (
                Number(this.objectif?.t1Prevu) +
                Number(this.objectif?.t2Prevu) +
                Number(this.objectif?.t3Prevu) +
                Number(this.objectif?.t4Prevu)
            );
        },
        sommeRealise() {
            return (
                Number(this.objectif?.t1Realise) +
                Number(this.objectif?.t2Realise) +
                Number(this.objectif?.t3Realise) +
                Number(this.objectif?.t4Realise)
            );
        }

    },
    watch: {
        imported: {
            immediate: true,
            handler(val) {
                if (val) this.payload.currentStep++;
            },
        },
    },
    mounted() {
    },
    methods: {
        ...mapActions('objectif', ['all', 'add']),
        isEmpty(value) {
            return value === null || value === '' || (typeof value === 'object' && Object.keys(value).length === 0);
        },
        onSearch(offset) {
            this.$loading(true);
            if (offset > 0) this.option.page = offset - 1;
            this.$router.push({ query: this.option }).catch(() => { });


        },
        getExercices() {
            this.$http.get('/exercice')
                .then(({ data }) => {
                    console.log(data);
                    console.log(1);
                    this.exercices = data;

                });
        },
        selectAnnee() {
            this.$loading(true);
            this.$http.get(`/objectifs/annee/${this.payload.exercice.annee}`)
                .then(({ data }) => {
                    console.log(data);
                    this.listObjectif = data;
                    this.localItems = data;

                    this.$loading(false);
                });
        },
        formatDate(dateStr) {
            const date = new Date(dateStr);
            return date.toLocaleDateString('fr-FR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        },
        sortBy(column) {
            if (this.currentSort === column) {
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
            } else {
                this.currentSort = column;
                this.currentSortDir = 'asc';
            }
        }, toggleAll() {
            this.allExpanded = !this.allExpanded;
            this.selectedItem = this.allExpanded ? 'ALL' : null;
        }, toggleDetail(item) {
            // Si déjà ouvert, fermer ; sinon, ouvrir
            if (this.selectedItem === item) {
                this.selectedItem = null;
            } else {
                this.selectedItem = item;
            }
        }, changePage(page) {
            if (page >= 1 && page <= this.pageCount) {
                this.currentPage = page;
            }
        },
        resolveSortValue(item) {
            const val = item[this.currentSort];
            if (this.currentSort === 'auteur') {
                return item.user?.firstname + ' ' + item.user?.lastname;
            }
            return typeof val === 'string' ? val.toLowerCase() : val;
        }, showPrevention(projet,info) {
            this.objectif = projet;
                 $('#detail-objectif').modal('show');
                if(info==true){
                    this.prevu = true;
                }else
                {
                    this.prevu = false;
                }
           
        },
        saver(data) {
            console.log(data);
              $('#detail-objectif').modal('hide');
            this.$loading(true);

            this.$http.put('/objectifs/' + data.id, data)
                .then((response) => {
                    const message = response.data?.message || 'Sauvegarde effectuée';
                    console.log(message);

                    swal('Information!', message, 'success');
                     this.$http.get(`/objectifs/annee/${this.payload.exercice.annee}`)
                        .then(({ data }) => {
                            console.log(data);
                            this.listObjectif = data;
                            this.localItems = data;

                            this.$loading(false);
                        });
                  
                    // Ferme le modal si le bouton est présent
                    this.objectif = {}
                })
                .catch((error) => {
                    console.error(error);
                    swal('Erreur!', 'Une erreur est survenue lors de la modification de l’objectif.', 'error');
                })
                .finally(() => {
                    this.$loading(false);
                });
        }


    },
    created() {
        this.onSearch()
        this.getExercices()
        this.$http.get('/typologiePta')
            .then(({ data }) => {
                console.log(data);
                console.log(1);
                this.typologies = data;
            });

        this.$http.get('/typeMesure')
            .then(({ data }) => {
                console.log(data);
                console.log(1);
                this.typeMesures = data;
            });

        this.$http.get('/echeance')
            .then(({ data }) => {
                console.log(data);
                console.log(1);
                this.echeances = data;
            });

        this.$http.get('/producteur')
            .then(({ data }) => {
                console.log(data);
                console.log(1);
                this.producteurs = data;
            });

        this.$http.get('/typeIndicateur')
            .then(({ data }) => {
                console.log(data);
                console.log(1);
                this.typeIndicateurs = data;
            });

        this.$http.get('/sourceIndicateur')
            .then(({ data }) => {
                console.log(data);
                console.log(1);
                this.sourceIndicateurs = data;
            });

        this.$loading(false);


    },
}
</script>

<style></style>